<div
  class="sub-nav-item"
  [attr.data-testid]="(navItem | navItemTestId) + '-' + subItem?.relativeRouterPath"
  (click)="navItemSelected(); $event.stopPropagation()"
  [class.sub-active]="viewModel.isNavItemActive$ | async">
  {{ subItem?.name }}
</div>
